// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M10.593.025a22.49 22.49 0 0 0-7.017 1.527c-.925.367-1.204.526-1.504.86a2.35 2.35 0 0 0-.559 1.196c-.033.246-.034 7.69 0 8.44.082 1.858.51 3.525 1.318 5.136.264.526.42.798.739 1.284.52.794.954 1.324 1.648 2.017 1.04 1.038 2.052 1.766 3.338 2.4.64.315 2.078.888 2.502.996a3.908 3.908 0 0 0 1.458.083c.449-.066.653-.133 1.848-.604 1.823-.72 3.291-1.693 4.61-3.057a12.606 12.606 0 0 0 3.393-6.928c.135-.927.133-.842.133-5.479V3.612l-.054-.213c-.145-.567-.51-1.08-.972-1.368-.455-.284-2.07-.885-3.294-1.226a22.46 22.46 0 0 0-4.416-.759c-.372-.032-2.699-.048-3.17-.021m-.058 1.512c-.8.052-1.93.191-2.586.318l-.272.053 6.384 6.48c3.511 3.563 6.393 6.482 6.405 6.486.045.015.297-1.007.386-1.566.14-.88.135-.681.135-5.316v-4.26l-.067-.137c-.122-.248-.276-.337-1.193-.69-1.892-.73-3.723-1.152-5.808-1.336-.514-.045-2.839-.067-3.384-.032M5.7 2.412c-.752.23-1.761.606-2.235.83-.216.103-.296.18-.39.382-.06.127-.063.15-.071.67l-.009.537 7.328 7.328 7.328 7.328.153-.15c.679-.666 1.407-1.666 1.917-2.633l.146-.276-6.502-6.6C9.788 6.198 6.66 3.026 6.413 2.78l-.449-.449-.264.081M3.007 9.66c.01 2.567.012 2.706.06 3.09.062.484.106.751.189 1.134a11.19 11.19 0 0 0 4.1 6.491c.657.51 1.418.966 2.196 1.316.403.182 1.588.642 1.86.723a2.16 2.16 0 0 0 1.308-.045 27.043 27.043 0 0 0 1.848-.732c.634-.295 1.43-.766 1.888-1.117.051-.04-.043-.135-6.703-6.794L2.998 6.972l.01 2.688"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

const DefaultIcon = Icon;
export default DefaultIcon;
